// VideoOne component - Converted from components/VideoOne.vue
// Video section with external video link
import React from 'react';
import videoBg from '../assets/images/main-slider/agro-header.mp4';

const VideoOne: React.FC = () => {
  return (
    <section className="video-one">
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0
        }}
      >
        <source src={videoBg} type="video/mp4" />
      </video>
      <div className="container text-center" style={{ position: 'relative', zIndex: 2 }}>
        <a 
        
          href="https://www.facebook.com/people/Leaders-Agro-Elite/61585236126030/?sk=reels_tab"
          className="video-one__btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-play"></i>
        </a>
        <h3 style={{fontSize: '3rem'}}>
        L'agriculture durable, notre engagement pour l'avenir
        </h3>
      </div>
    </section>
  );
};

export default VideoOne;
